<p-dialog 
    [(visible)]="visible" 
    [modal]="true" 
    [style]="{width: '50vw'}" 
    header="Dispatch Orders">
    <div class="flex flex-column gap-3">
        <!-- Email input field -->
        <div class="field">
            <label for="email" class="text-lg block mb-2">Send Email to Truck Number: {{ displayTruckNumber }}</label>
            <div class="p-inputgroup">
                <span class="p-inputgroup-addon">
                    <i class="pi pi-envelope"></i>
                </span>
                <input 
                    type="email" 
                    pInputText 
                    id="email" 
                    [(ngModel)]="emailAddress" 
                    [placeholder]="defaultTruckEmail"
                    class="w-full"
                    >
            </div>
        </div>
        
        <!-- Dispatch text area -->
        <div class="field">
            <label for="dispatchText" class="block mb-2">Dispatch Details</label>
            <textarea 
                id="dispatchText"
                pInputTextarea 
                [(ngModel)]="dispatchText" 
                [rows]="20" 
                [autoResize]="true" 
                class="w-full"
                placeholder="Dispatch orders will appear here...">
            </textarea>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <div class="flex justify-content-end gap-2">
            <p-button 
                label="Send Email" 
                icon="pi pi-envelope"
                [disabled]="!isValidEmail() || sending"
                [loading]="sending"
                (onClick)="sendEmail()">
            </p-button>
            <p-button 
                label="Close" 
                icon="pi pi-times"
                (onClick)="closeEmailDialog()">
            </p-button>
        </div>
    </ng-template>
</p-dialog>

<!-- Toast for notifications -->
<p-toast></p-toast>
